import BookmakerModel from '@mediaplatform/sportal365-odds-utils/types/models/bookmaker.model';
import {
  BETTING_LOGO_ENTITY,
  BETTING_M_VALUE_ENTITY,
  COACH_ENTITY,
  COMPETITION_ENTITY,
  EVENT_ENTITY,
  PLAYER_ENTITY,
  TEAM_ENTITY,
} from '../../constants/entityTypes';
import {
  BETTING_LOGO_SUBSCRIBE_TYPE,
  BETTING_MARKET_VALUE_SUBSCRIBE_TYPE,
  COACH_SUBSCRIBE_TYPE,
  COMPETITION_SUBSCRIBE_TYPE,
  EVENT_SUBSCRIBE_TYPE,
  PLAYER_SUBSCRIBE_TYPE,
  TEAM_SUBSCRIBE_TYPE,
  USER_INTERACTION_SUBSCRIBE_TYPE,
} from '../../constants/subscribeTypes';
import {
  EntityTypes,
  INormalizedTennisParticipantDetails,
  IOddProvider,
  ISubscriberInfo,
  ISubscriberInfoFn,
  ITournament,
  OddsMarketTypes,
} from '../../types';
import { Bookmaker } from '../../odds/types/bookmakers';

export const defaultHandleCompetitionClick = (handleClick: ISubscriberInfoFn, competition: ITournament) => {
  handleClick(
    {
      id: competition.id,
      name: competition.name,
      entity_type: COMPETITION_ENTITY,
    },
    COMPETITION_SUBSCRIBE_TYPE,
  );
};

export const defaultHandleOddProviderClick = (handleClick: ISubscriberInfoFn, oddProvider?: IOddProvider) => {
  handleClick(
    {
      id: oddProvider?.id,
      name: oddProvider?.name,
      link: oddProvider?.url,
      entity_type: BETTING_LOGO_ENTITY,
    },
    BETTING_LOGO_SUBSCRIBE_TYPE,
  );
};

export const defaultHandleTeamClick = (handleClick: ISubscriberInfoFn, { id, name }: { id: string | number; name: string }) => {
  handleClick(
    {
      id,
      name,
      entity_type: TEAM_ENTITY,
    },
    TEAM_SUBSCRIBE_TYPE,
  );
};

export const defaultHandleEventClick = (handleClick: ISubscriberInfoFn, event: string | number) => {
  handleClick(
    {
      id: event,
      entity_type: EVENT_ENTITY,
    },
    EVENT_SUBSCRIBE_TYPE,
  );
};

export const defaultHandleTournamentClick = (handleClick: ISubscriberInfoFn, id: string | number, name?: string) => {
  handleClick(
    {
      id,
      name,
      entity_type: COMPETITION_ENTITY,
    },
    COMPETITION_SUBSCRIBE_TYPE,
  );
};

export const defaultHandleParticipantClick = (
  handleClick: (info: ISubscriberInfo, clickType: string) => void,
  { id, name, entityType }: Pick<INormalizedTennisParticipantDetails, 'id' | 'name' | 'entityType'>,
) => {
  handleClick(
    {
      id,
      name,
      entity_type: entityType === TEAM_ENTITY ? TEAM_ENTITY : PLAYER_ENTITY,
    },
    entityType === TEAM_ENTITY ? TEAM_SUBSCRIBE_TYPE : PLAYER_SUBSCRIBE_TYPE,
  );
};

export const defaultHandlePlayerClick = (handleClick: ISubscriberInfoFn, id: string | number, name: string) => {
  handleClick(
    {
      id,
      name,
      entity_type: PLAYER_ENTITY,
    },
    PLAYER_SUBSCRIBE_TYPE,
  );
};

export const defaultHandleCoachClick = (handleClick: ISubscriberInfoFn, id: string | number, name: string) => {
  handleClick(
    {
      id,
      name,
      entity_type: COACH_ENTITY,
    },
    COACH_SUBSCRIBE_TYPE,
  );
};

export const defaultHandleUserInteractionClick = (handleClick: ISubscriberInfoFn, name: string, entityType: EntityTypes) => {
  handleClick(
    {
      name,
      entity_type: entityType,
    },
    USER_INTERACTION_SUBSCRIBE_TYPE,
  );
};

export const defaultHandleBettingMarketValueClick = (
  handleClick: ISubscriberInfoFn,
  bookmaker: BookmakerModel,
  market: OddsMarketTypes,
  link: string,
) => {
  handleClick(
    {
      name: bookmaker.name,
      id: bookmaker.id,
      entity_type: BETTING_M_VALUE_ENTITY,
      market,
      link,
    },
    BETTING_MARKET_VALUE_SUBSCRIBE_TYPE,
  );
};

export const defaultHandleBettingMarketValueClickNew = (
  handleClick: ISubscriberInfoFn,
  bookmaker: Bookmaker,
  market: OddsMarketTypes,
  link: string,
) => {
  handleClick(
    {
      name: bookmaker.name,
      id: bookmaker.id,
      entity_type: BETTING_M_VALUE_ENTITY,
      market,
      link,
    },
    BETTING_MARKET_VALUE_SUBSCRIBE_TYPE,
  );
};
